import { format } from 'date-fns'

const IS_PRODUCTION = import.meta.env.VITE_ENV === 'production'

// ORS is backed by deployed AWS resources, so a local API can't serve it.
export const IS_LOCAL_API = /^https?:\/\/(localhost|127\.0\.0\.1)/.test(
  import.meta.env.VITE_API_URL ?? ''
)
export const THEMES = {
  MAIN: 'MAIN',
}

export const GROUPS = {
  admin: 'admin',
  partner: 'partner',
  installer: 'installer',
}

export const customDateFormat = (date: Date | string, time?: boolean) =>
  format(new Date(date), time ? 'd LLL y | HH:mm' : 'd LLL y')

export const FLAGS = {
  PRIZE_DRAWS: true,
  MAPPING_V2: !IS_PRODUCTION,
} as const
